import { AddReportButton } from '@/components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GenerateTasksReportModal } from './GenerateTasksReportModal';

export function GenerateTasksReportButton() {
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <AddReportButton onClick={() => setOpenModal(true)}>
        {t('reports.tasksReport.title')}
      </AddReportButton>
      {openModal && (
        <GenerateTasksReportModal onClose={() => setOpenModal(false)} />
      )}
    </>
  );
}
